import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  mergeCmsDataRequest: ["cb"],
  mergeCmsDataSuccess: ["payload"],
  mergeCmsDataFailure: null,
});

export const MergeCmsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: false,
  error: false,
  payload: null,
});

export const request = (state) => state.merge({ fetching: true, error: false });
export const success = (state, action) =>
  state.merge({ fetching: false, error: false, payload: action.payload });
export const failure = (state) => state.merge({ fetching: false, error: true });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.MERGE_CMS_DATA_REQUEST]: request,
  [Types.MERGE_CMS_DATA_SUCCESS]: success,
  [Types.MERGE_CMS_DATA_FAILURE]: failure,
});
